
import React, {useState,useEffect} from 'react';
import * as S from './SelectSeatTabContent.styles';
import Icon from '../../../../../../stories/core-components/IconsSelector';
import useCarousel from './../../../../../containers/Common/useCarousel'


const PriceTabView = props => {
    const {data,
    selectedPrice,
    route_id,
    bid,
    selectedSeatLayoutInfo,
    onPriceSelect} = props;

    const {
      dataList,
      increment,
      decrement,
      isLeftCursorActive,
      isRightCursorActive,
      leftCursor,
      rightCursor,
    } = useCarousel(data, 6);
    const view  = priceTabViewData(dataList,selectedPrice,route_id,bid,selectedSeatLayoutInfo,onPriceSelect);
  return(
      <>
      {isLeftCursorActive ?  <S.SliderArrowLeft 
    data-testid="busOfferCarouselLeftArrowBtn"
    onClick={()=>{
      decrement();
    }}>
        <Icon name="ArrowRight" styleProps={{fill: '#2276e3', transform: 'rotate(-180deg)'}} />
      </S.SliderArrowLeft>:null}
      <S.PriceViewWrapper>
      {view}
      </S.PriceViewWrapper>
      {isRightCursorActive?   <S.SliderArrowRight 
   data-testid="busOfferCarouselRightArrowBtn"
   onClick={()=>{
     increment();
   }}>
        <Icon name="ArrowRight" styleProps={{fill: '#2276e3'}} />
      </S.SliderArrowRight> :null}
      </>
  )
};

export default PriceTabView;

function priceTabViewData(
    data,
    selectedPrice,
    route_id,
    bid,
    selectedSeatLayoutInfo,
    onPriceSelect,
  ) {
      
    let viewData = [];
  
    for (let i in data) {
      viewData.push(
        <S.PriceTabs
          key={data[i] + route_id}
          className={`${selectedPrice.indexOf(data[i]) !== -1 ? 'active' : ''}`}
          onClick={() => {
            onPriceSelect({bid, price: data[i], selectedSeatLayoutInfo});
          }}
        >
          <span>{data[i] === -1 ? 'All' : `₹ ${data[i]}`}</span>
        </S.PriceTabs>
      );
     
    
    }
    return viewData;
  }